<template>
  <div class="footer w-100">
    <audio id="audio_zen" v-show="false">
      <source
        v-for="(track, index) of global.ZEND_SOUNDS"
        :key="index"
        :data-track-number="index"
        :src="`${global.ZEND_MUSIC_URI}${track}`"
        type="audio/mpeg"
      />
    </audio>
    <SaveConfUtil />
    <div class="d-flex justify-space-between align-center" v-if="currentStage === 'bookReading'">
      <div>
        <!-- <x-ArrowButtonOutline :width="'190px'" :height="'10vh'" @brClick="back"> -->
        <x-ArrowButtonOutline :width="'100%'" :height="'10vh'" @brClick="back">
          <span class="gradient-purple-text">
            {{ $t('go_back') }}
          </span>
        </x-ArrowButtonOutline>
      </div>
      <!-- <div class="py-2 px-3 bg-white shadow-lg border-radius-2">
        <span class="text-upppercase text-center footer-text">
          {{ currentPage }}
          <span class="opacity-6">{{ $t('of') }} {{ structTotalPages }}</span>
        </span>
      </div> -->
      <div>
        <x-ArrowButton :width="'100%'" :height="'10vh'" @brClick="next">
          <span class="white--text text-body-2 font-weight-bold" :data-cy="`footer-next-btn-${parentComponent}`">
            {{ $t('next') }}
          </span>
        </x-ArrowButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'

import global from '@/constants/GlobalConstant'
import readingTimeConstant from '@/constants/ReadingTimeConstant'

import BookUserCatalogService from '@/services/bookUserCatalog'
import BookReadingService from '@/services/bookReading'

import SaveConfUtil from './bookUtils/utils/SaveConfUtils.vue'

export default {
    props:['parentComponent'],
  components: {
    SaveConfUtil,
  },
  computed: {
    ...mapState({
      currentStage: (state) => state.bookReading.currentStage,
      currentPage: (state) => state.bookReading.currentPage,
      structTotalPages: (state) => state.bookReading.book.structTotalPages,
      book: (state) => state.bookReading.book,
      user: (state) => state.userData.user,
      catalog: (state) => state.bookReading.catalog,
      currentChapter: (state) => state.bookReading.currentChapter,
      currentChapterData: (state) => state.bookReading.currentChapterData,
      bookAssessmentData: (state) => state.bookReading.bookAssessmentData,
      questionsForChapter: (state) => state.bookReading.questionsForChapter,
      soundActive: (state) => state.bookReading.bookReadConf.soundActive,
      sound: (state) => state.bookReading.bookReadConf.sound,
      itemsData: (state) => state.bookReading.itemsData,
      tipsData: (state) => state.bookReading.tipsData,
      indexItem: (state) => state.bookReading.indexItem,
      itemType: (state) => state.bookReading.itemType,
      currentQuestion: (state) => state.bookReading.currentQuestion,
      indexQuestion: (state) => state.bookReading.indexQuestion,
      hasQuestion: (state) => state.bookReading.hasQuestion,
      isRecommended: (state) => state.bookReading.isRecommended,
      readingTime: (state) => state.bookReading.readingTime,
    }),
    playSound() {
      return this.soundActive
    },
    volume() {
      return this.sound
    },
  },
  watch: {
    playSound() {
      this.playBackgroundMusic()
    },
    volume(newValue) {
      this.setVolume(newValue)
    },
  },
  data() {
    return {
      readingTimer: null,
      seconds: 1,
      global,
      zenIndex: 0,
    }
  },
  mounted() {
    const vm = this
    this.readingTimer = setInterval(() => {
      vm.seconds += 1
    }, readingTimeConstant.MIN_TIME_IN_MILIS)
    this.playBackgroundMusic()
    this.setVolume(this.sound)
  },
  methods: {
    ...mapActions('bookReading', [
      'increaseCurrentPage',
      'decreaseCurrentPage',
      'setCurrentChapter',
      'setCurrentChapterData',
      'setCurrentStage',
      'setItemsData',
      'setItemType',
      'setQuestionForChapter',
      'setTipsData',
      'setCurrentQuestion',
      'showQuestions',
      'setHasQuestion',
      'setLastQuestionOfGroup',
      'setLastQuestionOfBook',
      'updateReadingTime',
    ]),
    next() {
      if (this.hasQuestion) {
        this.uploadReadingProgressPage();
        this.showQuestions()
        this.$root.$emit('openQuestionsSheet');
        return
      }
      window.scrollTo(0, 0)
      if (this.currentPage === this.book.structTotalPages) {
        this.uploadReadingProgressPage();
        this.setCurrentStage('bookEnd')
        return
      }
      this.increaseCurrentPage()
      if (this.currentPage > this.currentChapterData.structFinalPage) {
        this.setCurrentChapter(this.currentChapter + 1)
        this.setCurrentChapterData(this.book.bookChapterDTOList[this.currentChapter - 1])
      }
      this.uploadReadingProgressPage();
      const currentPage = document.querySelector('.current-page')
      if (currentPage) {
        const wordsOnPage = currentPage.innerHTML.split(' ').length
        const words = (wordsOnPage / (this.seconds || 1)).toFixed()
        BookReadingService.uploadUserReadingSpeed({
          userId: this.user.id,
          readingSpeed: words,
        })
      }
      this.seconds = 1
      this.updateReadingTime(0)
      this.getQuestionsForPage()
    },
    back() {
      if (this.currentPage === this.book.bookChapterDTOList[0].structInitialPage) {
        this.$router.push('/user/library')
        return
      }
      window.scrollTo(0, 0)
      this.decreaseCurrentPage()
      if (this.currentPage < this.currentChapterData.structInitialPage) {
        this.setCurrentChapter(this.currentChapter - 1)
        this.setCurrentChapterData(this.book.bookChapterDTOList[this.currentChapter - 1])
      }
      this.seconds = 1
      this.setHasQuestion(false)
    },
    getQuestionsForPage() {
      const { ordinalGrade } = this.user.course
      const vm = this
      this.setItemsData(
        this.bookAssessmentData.filter(
          (element) => !element.fragment.questionsAtEndOfChapter
                       && element.fragment.structChapterPage === vm.currentPage
        )
      )
      if (this.itemsData.length > 0) {
        this.setItemType(this.itemsData[this.indexItem].itemType)
        this.setQuestionForChapter(this.itemsData[this.indexItem].questions)
        this.setTipsData(
          this.filterByGrade(this.itemsData[this.indexItem].aimOfAssessment.tips, ordinalGrade)
        )
        this.questionsForChapter.sort((a, b) => {
          return this.orderQuestions(a, b)
        })
        this.setCurrentQuestion(this.questionsForChapter[this.indexQuestion])
        const index = this.bookAssessmentData.indexOf(this.itemsData[this.indexItem])
        this.setLastQuestionOfGroup(this.indexItem === this.itemsData.length - 1)
        this.setLastQuestionOfBook(index === this.bookAssessmentData.length - 1)
        this.setHasQuestion(true)
        return
      }

      this.setItemsData(
        this.bookAssessmentData.filter(
          (element) =>
            element.fragment.questionsAtEndOfChapter &&
            element.fragment.chapter.structFinalPage === vm.currentPage
        )
      )
      if (this.itemsData.length > 0) {
        this.setItemType(this.itemsData[this.indexItem].itemType)
        this.setQuestionForChapter(this.itemsData[this.indexItem].questions)
        this.setTipsData(
          this.filterByGrade(this.itemsData[this.indexItem].aimOfAssessment.tips, ordinalGrade)
        )
        this.questionsForChapter.sort((a, b) => {
          return this.orderQuestions(a, b)
        })
        this.setCurrentQuestion(this.questionsForChapter[this.indexQuestion])
        const index = this.bookAssessmentData.indexOf(this.itemsData[this.indexItem])
        this.setLastQuestionOfGroup(this.indexItem === this.itemsData.length - 1)
        this.setLastQuestionOfBook(index === this.bookAssessmentData.length - 1)
        this.setHasQuestion(true)
        return
      }

      this.setHasQuestion(false)
    },
    filterByGrade(tips, grade) {
      const result = []
      tips.forEach((tip) => {
        if (tip.educationLevel === 'ALL') {
          result.push(tip)
        }

        if (grade >= 1 && grade <= 6 && tip.educationLevel === 'PRIMARY') {
          result.push(tip)
        }

        if (grade >= 7 && grade <= 12 && tip.educationLevel === 'SECONDARY') {
          result.push(tip)
        }
      })
      return result
    },
    orderQuestions(a, b) {
      if (a.itemVariant > b.itemVariant) {
        return 1
      }
      if (a.itemVariant < b.itemVariant) {
        return -1
      }
      return 0
    },
    playBackgroundMusic() {
      const audioZen = document.getElementById('audio_zen')
      const vm = this
      if (audioZen) {
        const songURL = audioZen.children[this.zenIndex].src

        audioZen.setAttribute('src', songURL)
        audioZen.onended = () => {
          vm.zenIndex += 1
          if (audioZen.children.length - 1 < vm.zenIndex) {
            vm.zenIndex = 0
          }
          const nextSong = audioZen.children[this.zenIndex].src
          audioZen.setAttribute('src', nextSong)
          setTimeout(() => audioZen.play(), global.ZEND_PLAY_DELAY)
        }
        if (this.soundActive) {
          setTimeout(() => {
            const audioContext = new AudioContext();
            audioContext.onstatechange = () => {
              if (audioContext.state !== 'suspended') audioZen.play();
            }
          }, global.ZEND_PLAY_DELAY)
        } else this.pausePlayer(audioZen)
      }
    },
    pausePlayer(player) {
      player.pause()
    },
    setVolume(vol) {
      const audioZen = document.getElementById('audio_zen')
      if (audioZen) audioZen.volume = vol / 100
    },
    uploadReadingProgressPage() {
      BookUserCatalogService.uploadReadingProgress({
          catalogId: this.catalog.id,
          page: this.currentPage,
          recommended: this.isRecommended,
          readingTime:
            this.readingTime === 0 ? readingTimeConstant.MIN_TIME_IN_MILIS : this.readingTime,
        }).catch((err) => {
          Sentry.captureException(err)
        });
    }
  },
  beforeDestroy() {
    window.clearInterval(this.readingTimer)
  },
}
</script>
